<script setup>
import { Loc } from 'main.core';
import CalculatorParam from './CalculatorParam.vue';
import useCalculatorStore from '../store/calculator.js';

const calculator = useCalculatorStore();
</script>

<template>
  <CalculatorParam>
    <template #title>
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_PARAMS_PERIOD') }}
    </template>
    <template #subtitle>
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_PARAMS_PERIOD_HINT') }}
    </template>
    <div class="cloud-calculator__radio-buttons">
      <label
        class="cloud-calculator__radio-button"
        v-for="period in calculator.periods"
        :key="period.id"
        :for="`cloud-calculator-period-${period.id}`"
      >
        <input
          type="radio"
          name="cloud-calculator-period"
          :value="period.id"
          :checked="calculator.selectedPeriod === period.id"
          :id="`cloud-calculator-period-${period.id}`"
          @change="calculator.selectedPeriod = period.id"
        >
        <span>{{ period.name }}</span>
      </label>
    </div>
  </CalculatorParam>
</template>
